import { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const fromIso = (value) => {
  if (!value) return undefined;
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
};

const toIso = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
const toPt = (value) => {
  const date = fromIso(value);
  return date ? date.toLocaleDateString('pt-PT') : '';
};

export const DatePickerField = ({ value, onChange, testid, placeholder = 'Escolher data', className = '' }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`flex w-full items-center gap-2 rounded-xl border border-eco-ink/15 bg-white px-4 py-2.5 text-left text-sm text-eco-ink outline-none transition-colors focus:border-eco-gold ${className}`}>
          <CalendarDays size={15} className="shrink-0 text-eco-gold" />
          <span className={value ? 'text-eco-ink' : 'text-eco-ink/40'}>{toPt(value) || placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent data-testid={`${testid}-popover`} className="w-auto border-eco-ink/10 bg-white p-0 shadow-xl">
        <Calendar
          mode="single"
          selected={fromIso(value)}
          onSelect={(date) => {
            if (date) onChange(toIso(date));
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
